import React, { useState, useEffect } from "react";
import {
    FaCalendarCheck,
    FaCalendarAlt,
    FaThumbsUp,
    FaThumbsDown,
    FaUserEdit,
    FaUserPlus,
    FaBalanceScale,
    FaArrowRight,
} from "react-icons/fa";
import { fetchData } from '../../../apiService';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';

const UserPlan = () => {
    const { id } = useParams(); // here use the id as userid
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const history = useHistory();
    const closeModal = () => setSelectedPlan(null);
    
    const fetchtableData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('SubscriptionPlansApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setPlans(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtableData();
    }, []);

    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '10px',
        marginRight: '8px',
    };

    const handleArrowClick = (e, pid) => {
        e.stopPropagation(); // Prevents modal from opening
        history.push(`/payment/${id}/${pid}`); // Navigates to payment page
    };

    return (
        <div style={{ padding: "30px", fontFamily: "monospace" }}>
            <div className="flex items-center justify-between mb-4">
                <h5 className="font-bold text-green-800 text-center flex-1" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke' }}>
                    Subscription Plan
                </h5>
            </div>

            <div style={{ padding: "20px" }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        maxWidth: "600px",
                        margin: "0 auto",
                    }}
                >
                    {plans.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => setSelectedPlan(item)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                background: "#2E2E2E",
                                padding: "20px",
                                borderRadius: "16px",
                                color: "#fff",
                                boxShadow: "4px 4px 10px rgba(255, 255, 255, 0.1)",
                                cursor: "pointer",
                                transition: "transform 0.2s",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <div>
                                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#80ff80" }}>
                                    {item.name}
                                </div>
                                <div style={{ fontSize: "14px", margin: "4px 0", color: "#ccc" }}>
                                    Duration: {item.planDuration} days
                                </div>
                                <div style={{ fontSize: "14px", color: "#bbb" }}>{item.description}</div>
                            </div>
                            <div style={{ fontSize: "20px", color: "#FFD700", fontWeight: "bold" }}>
                                ₹{item.amount}
                            </div>
                            {/* Arrow Icon */}
                            <FaArrowRight
                                size={24}
                                style={{ color: "#fff", cursor: "pointer" }}
                                onClick={(e) => handleArrowClick(e, item.id)}
                            />
                        </div>
                    ))}
                </div>

                {/* Modal */}
                {selectedPlan && (
                    <div
                        onClick={closeModal}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: "#fff",
                                color: "#000",
                                borderRadius: "12px",
                                padding: "30px",
                                width: "90%",
                                maxWidth: "400px",
                                textAlign: "center",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                            }}
                        >
                            <h4 style={{ marginBottom: "10px", color: "#040661ff", fontFamily: 'monospace' }}>{selectedPlan.name} Plan</h4>
                            <p style={{ fontFamily: 'monospace' }}>Duration: {selectedPlan.planDuration} days</p>
                            <p style={{ fontFamily: 'monospace' }}>{selectedPlan.description}</p>
                            <p style={{ fontWeight: "bold", color: "#811109ff", fontFamily: 'monospace', fontSize: '20px' }}>₹{selectedPlan.amount}</p>
                            <button
                                onClick={closeModal}
                                style={{
                                    marginTop: "20px",
                                    padding: "10px 20px",
                                    backgroundColor: "#2E2E2E",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
            </div>

        </div>

    );
};

export default UserPlan;
